<template>
  <div>
    <v-select
      :value="value"
      :label="label"
      clearable
      :items="filteredItems"
      item-value="id"
      item-text="label"
      @change="onChange"
      no-data-text="Seleccione um diagnóstico primeiro"
      :menu-props="{ contentClass: 'procedure-select' }"
    >
      <template v-slot:item="data">
        <template>
          <span class="my-1">
            {{ data.item.label }}
          </span>
        </template>
      </template>
    </v-select>
  </div>
</template>

<script>
import { NeurosurgeryProcedure } from '../../../models/Neurosurgery'
export default {
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    diagnosisSelected: { type: Array, default: () => [] }
  },

  computed: {
    filteredItems() {
      const diagnosis =
        this.diagnosisSelected && this.diagnosisSelected[0]
          ? this.diagnosisSelected[0]
          : ''
      const query = NeurosurgeryProcedure.query().where(l =>
        l.diagnosisId.includes(diagnosis)
      )
      return query.get().map(item => ({
        id: item.id,
        label: item.label + ' : ' + item.icd10
      }))
    }
  },
  methods: {
    onChange(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style>
div.procedure-select a {
  height: 100%;
}
</style>
